import type { FilterConfig } from '@/types/filters.types';
import { leadSourceFilterConfig } from '@/hooks/filters/leadSourceOptions';

/**
 * Filter keys MUST match the canonical legacy filter registry.
 * DO NOT rename keys or change option values — dynamic lists store these permanently.
 * See lib/filterRegistry.ts for the full registry and rules.
 */
export function buildPlanFilterConfigs(doctorLabel: string, coordLabel: string): FilterConfig[] {
  return [
    { key: 'search', label: 'Search', type: 'search', allLabel: 'Search plans...' },
    { key: 'daterange', label: 'Date', type: 'daterange' },
    { key: 'appt-type', label: 'Appt Type', type: 'select', allLabel: 'All appt types', multi: true },
    { key: 'plan-type', label: 'Plan Type', type: 'select', allLabel: 'All plan types', multi: true },
    leadSourceFilterConfig('Lead Source', 'All lead sources'),
    { key: 'utm-source', label: 'UTM Source', type: 'select', allLabel: 'All UTM sources', multi: true, searchable: true },
    { key: 'membership-type', label: 'Membership', type: 'select', allLabel: 'All memberships', multi: true },
    { key: 'plan-stages', label: 'Stage', type: 'select', allLabel: 'All stages', multi: true },
    { key: 'plan-status', label: 'Status', type: 'select', allLabel: 'All statuses', multi: true },
    { key: 'doctor', label: doctorLabel, type: 'select', allLabel: `All ${doctorLabel.toLowerCase()}s`, multi: true },
    { key: 'coordinator', label: coordLabel, type: 'select', allLabel: `All ${coordLabel.toLowerCase()}s`, multi: true },
    { key: 'facility', label: 'Facility', type: 'select', allLabel: 'All facilities', multi: true },
  ];
}
